import React from "react";
import { Link, NavLink } from "react-router-dom";

import styles from "./style.module.scss";

type LinkProps = {
  to: string;
  children: React.ReactNode;
  end?: boolean;
  // Overrides matching the path when present
  active?: boolean;
};

export const PageNavLink = ({ to, end, active, children }: LinkProps) => {
  if (active !== undefined) {
    return (
      <Link
        to={to}
        className={active ? styles.active : undefined}
        aria-current={active ? "page" : undefined}
      >
        {children}
      </Link>
    );
  }
  return (
    <NavLink
      to={to}
      className={({ isActive }) => (isActive ? styles.active : undefined)}
      end={end === undefined || end}
    >
      {children}
    </NavLink>
  );
};

type Props = {
  children: React.ReactNode;
  variant?: "page" | "section";
};

const PageSecondaryNavigation = ({ children, variant = "page" }: Props) => {
  return (
    <div className={variant === "section" ? styles.section : styles.container}>
      {children}
    </div>
  );
};

export default PageSecondaryNavigation;
